<script setup lang="ts">
import { NForm } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  model?: any
  rules?: any
  labelPlacement?: 'left' | 'top'
  labelAlign?: 'left' | 'right'
  labelWidth?: string | number
  requireMarkPlacement?: 'left' | 'right' | 'right-hanging'
  showRequireMark?: boolean
  showFeedback?: boolean
  showLabel?: boolean
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  inline?: boolean
  validateOnRuleChange?: boolean
  onValidate?: (errors: any) => void
  onUpdateModelValue?: (value: any) => void
}>(), {
  model: undefined,
  rules: undefined,
  labelPlacement: 'left',
  labelAlign: 'left',
  labelWidth: undefined,
  requireMarkPlacement: 'right',
  showRequireMark: true,
  showFeedback: true,
  showLabel: true,
  size: 'medium',
  disabled: false,
  inline: false,
  validateOnRuleChange: true,
})

const emit = defineEmits<{
  'validate': [errors: any]
  'update:modelValue': [value: any]
}>()

const attrs = useAttrs()

const onValidate = (errors: any) => {
  emit('validate', errors)
}

const onUpdateModelValue = (value: any) => {
  emit('update:modelValue', value)
}
</script>

<template>
  <NForm
    :model="model"
    :rules="rules"
    :label-placement="labelPlacement"
    :label-align="labelAlign"
    :label-width="labelWidth"
    :require-mark-placement="requireMarkPlacement"
    :show-require-mark="showRequireMark"
    :show-feedback="showFeedback"
    :show-label="showLabel"
    :size="size"
    :disabled="disabled"
    :inline="inline"
    :validate-on-rule-change="validateOnRuleChange"
    v-bind="attrs"
    @validate="onValidate"
    @update:model-value="onUpdateModelValue"
  >
    <slot />
  </NForm>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
